import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Icon } from '@iconify/react';

function LandingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedPlans, setSelectedPlans] = useState({
    basic: { accounts: 1 },
    professional: { accounts: 1 },
    brand: { accounts: 1 }
  });

  const handleAccountChange = (planType, accounts) => {
    setSelectedPlans(prev => ({
      ...prev,
      [planType]: { accounts: accounts }
    }));
  };

  const handlePurchase = (planType, planName, pricePerAccount) => {
    const accounts = selectedPlans[planType].accounts;
    const totalPrice = pricePerAccount * accounts;
    
    // 創建購買數據
    const purchaseData = {
      planType,
      planName,
      pricePerAccount,
      accounts,
      totalPrice
    };
    
    // 儲存到 localStorage 準備付款
    localStorage.setItem('pendingPurchase', JSON.stringify(purchaseData));
    
    // 導向註冊/登入頁面
    if (user) {
      navigate('/checkout', { state: purchaseData });
    } else {
      navigate('/register', { state: { returnTo: '/checkout', purchaseData } });
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: "var(--bg-primary)",
      color: 'var(--text-primary)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Navigation Bar */}
      <nav className="responsive-container" style={{
        padding: 'clamp(1rem, 3vw, 1.5rem) 5%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        flexWrap: 'wrap',
        gap: 'clamp(0.5rem, 2vw, 1rem)'
      }}>
        <div className="responsive-heading" style={{
          fontSize: 'var(--font-base)',
          fontWeight: '700',
          color: '#3b82f6'
        }}>
          ViralArc AI
        </div>
        <div className="flex-container" style={{ gap: 'clamp(0.5rem, 2vw, 1rem)', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          {user ? (
            <>
              <span style={{ 
                color: 'var(--text-secondary)', 
                fontSize: 'var(--font-xxs)',
                marginRight: '1rem'
              }}>
                歡迎回來，{user.name}
              </span>
              <button
                onClick={() => navigate('/home')}
                style={{
                  background: "white",
                  border: 'none',
                  color: '#3b82f6',
                  padding: 'clamp(0.4rem, 1vw, 0.5rem) clamp(1rem, 3vw, 1.5rem)',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: 'var(--font-xxs)',
                  fontWeight: '600',
                  boxShadow: '0 0 15px rgba(59, 130, 246, 0.4), 0 4px 12px rgba(59, 130, 246, 0.2)',
                  animation: 'glow 2s ease-in-out infinite alternate'
                }}
              >
                前往主控台
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate('/login')}
                style={{
                  background: 'transparent',
                  border: '1px solid rgba(255,255,255,0.3)',
                  color: 'var(--text-primary)',
                  padding: 'clamp(0.4rem, 1vw, 0.5rem) clamp(1rem, 3vw, 1.5rem)',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: 'var(--font-xxs)'
                }}
              >
                登入
              </button>
              <button
                onClick={() => navigate('/register')}
                style={{
                  background: "var(--bg-primary)",
                  border: 'none',
                  color: 'var(--text-primary)',
                  padding: 'clamp(0.4rem, 1vw, 0.5rem) clamp(1rem, 3vw, 1.5rem)',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: 'var(--font-xxs)',
                  fontWeight: '600'
                }}
              >
                立即開始
              </button>
            </>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="responsive-container" style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: 'var(--font-4xl)',
          fontWeight: '700',
          marginBottom: '1.5rem',
          lineHeight: '1.2'
        }}>
          我們是一家 <span style={{
            color: '#3b82f6'
          }}>AI 公司</span>，專注於社群自動化經營
        </h1>
        
        <p style={{
          fontSize: 'var(--font-xs)',
          color: 'var(--text-secondary)',
          marginBottom: 'clamp(2rem, 5vw, 3rem)',
          maxWidth: '800px',
          margin: '4rem auto',
          marginBottom: 'clamp(2rem, 5vw, 3rem)'
        }}>
          透過機器學習與自然語言處理，我們讓 Instagram、Threads、Facebook 的經營更高效、更智慧，幫助品牌在最短時間內獲得最大曝光。
        </p>

        <div className="flex-container" style={{ gap: 'clamp(0.5rem, 2vw, 1rem)', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/register')}
            style={{
              background: '#3b82f6',
              border: 'none',
              color: 'white',
              padding: 'clamp(0.75rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2.5rem)',
              borderRadius: '12px',
              fontSize: 'var(--font-xs)',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 0 20px rgba(59, 130, 246, 0.4), 0 10px 30px rgba(59, 130, 246, 0.3)',
              minWidth: 'clamp(200px, 40vw, 280px)',
              whiteSpace: 'nowrap',
              animation: 'glow 2s ease-in-out infinite alternate'
            }}
          >
            立即體驗 AI 社群經營
          </button>
          <button
            onClick={() => window.location.href = 'mailto:official@viralarc-ai.com'}
            style={{
              background: 'white',
              border: 'none',
              color: '#3b82f6',
              padding: 'clamp(0.75rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2.5rem)',
              borderRadius: '12px',
              fontSize: 'var(--font-xs)',
              fontWeight: '600',
              cursor: 'pointer',
              minWidth: 'clamp(180px, 35vw, 240px)',
              whiteSpace: 'nowrap',
              boxShadow: '0 0 20px rgba(59, 130, 246, 0.4), 0 8px 20px rgba(59, 130, 246, 0.3)',
              animation: 'glow 2s ease-in-out infinite alternate'
            }}
          >
            申請企業方案
          </button>
        </div>

        {/* Demo Video */}
        <div style={{
          marginTop: 'clamp(2rem, 6vw, 4rem)',
          borderRadius: 'clamp(12px, 3vw, 20px)',
          background: "var(--bg-primary)",
          border: '1px solid rgba(255,255,255,0.1)',
          padding: 'clamp(1rem, 3vw, 1.5rem)',
          minHeight: 'clamp(200px, 40vw, 400px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <video
            controls
            style={{
              width: '100%',
              height: 'clamp(180px, 35vw, 350px)',
              borderRadius: 'clamp(8px, 2vw, 16px)',
              objectFit: 'cover',
              display: 'block'
            }}
            poster={require('../../assets/image/new-landing-video-poster.jpg')} // 新的封面圖
          >
            {/* 如果想换视频 可以在这里更换 */}
            <source src={require('../../assets/video/landing-page-video.mov')} type="video/mp4" />
            <source src="/videos/demo-video.webm" type="video/webm" />
            您的浏览器不支持视频播放。
          </video>
        </div>
      </section>

      {/* Core Technology Section */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: 'var(--bg-card)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div className="responsive-container">
          <h2 className="responsive-heading" style={{
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 'clamp(2rem, 5vw, 3rem)'
          }}>
            我們的核心技術
          </h2>

          <div className="responsive-grid" style={{
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 'clamp(1rem, 3vw, 2rem)'
          }}>
            {[
              {
                icon: 'mdi:brain',
                title: '機器學習 (Machine Learning)',
                description: '持續學習市場數據，找出爆紅內容模式'
              },
              {
                icon: 'mdi:chat-processing',
                title: '自然語言處理 (NLP)',
                description: '自動生成符合人物設定的文案，模仿語氣和風格'
              },
              {
                icon: 'mdi:eye-outline',
                title: '電腦視覺 (Computer Vision)',
                description: '智慧排版，自動生成圖卡，符合品牌視覺'
              },
              {
                icon: 'mdi:lightning-bolt',
                title: '多帳號自動化經營',
                description: '同時管理數百個帳號，排程、追蹤、優化一次完成'
              }
            ].map((tech, index) => (
              <div
                key={index}
                style={{
                  background: 'var(--bg-card)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: 'clamp(12px, 2vw, 16px)',
                  padding: 'clamp(1.5rem, 4vw, 2rem)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <Icon 
                  icon={tech.icon} 
                  style={{ 
                    fontSize: 'var(--font-3xl)', 
                    marginBottom: 'clamp(0.5rem, 2vw, 1rem)',
                    color: '#667eea'
                  }} 
                />
                <h3 className="responsive-subheading" style={{ marginBottom: '0.5rem', fontWeight: '600' }}>
                  {tech.title}
                </h3>
                <p className="responsive-text" style={{ color: 'var(--text-secondary)' }}>
                  {tech.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Value Proposition */}
      <section className="responsive-container" style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)'
      }}>
        <h2 className="responsive-heading" style={{
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: 'clamp(2rem, 5vw, 3rem)'
        }}>
          差異化價值
        </h2>

        <div className="responsive-grid" style={{
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 'clamp(1rem, 3vw, 2rem)'
        }}>
          {[
            {
              number: '01',
              title: '不只是排程工具',
              description: '而是 AI 驅動的社群經營公司',
            },
            {
              number: '02',
              title: '全流程自動化',
              description: '從內容生成 → 圖卡製作 → 自動發佈 → 成效優化全自動化'
            },
            {
              number: '03',
              title: '專業級行銷服務',
              description: '讓中小企業、個人品牌用最低成本享受專業級的行銷服務'
            }
          ].map((value, index) => (
            <div key={index} className="flex-container" style={{ gap: 'clamp(1rem, 3vw, 1.5rem)', alignItems: 'flex-start',flexDirection:"column" }}>
              <div style={{
                fontSize: 'var(--font-xl)',
                fontWeight: '700',
                color: '#3b82f6',
                flexShrink: 0,
              }}>
                {value.number}
              </div>
              <div>
                <h3 className="responsive-subheading" style={{ marginBottom: '0.5rem', fontWeight: '600' }}>
                  {value.title}
                </h3>
                <p className="responsive-text" style={{ color: 'var(--text-secondary)' }}>
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Case Studies */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: 'var(--bg-card)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div className="responsive-container">
          <h2 className="responsive-heading" style={{
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 'clamp(2rem, 5vw, 3rem)'
          }}>
            案例數據
          </h2>

          <div className="responsive-grid" style={{
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: 'clamp(1rem, 3vw, 2rem)'
          }}>
            {[
              { stat: '2.5x', label: '平均互動率提升', desc: '測試用戶 30 位' },
              { stat: '70%', label: '時間節省', desc: '相比人工文案創作' },
              { stat: '200萬+', label: '觸及人次', desc: '30 天內，10 個帳號' }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  textAlign: 'center',
                  padding: 'clamp(1.5rem, 4vw, 2rem)',
                  background: "var(--bg-primary)",
                  borderRadius: 'clamp(12px, 2vw, 16px)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
              >
                <div style={{
                  fontSize: 'var(--font-3xl)',
                  fontWeight: '700',
                  color: '#3b82f6',
                  marginBottom: '0.5rem'
                }}>
                  {item.stat}
                </div>
                <div style={{ fontSize: 'var(--font-xs)', marginBottom: '0.5rem' }}>{item.label}</div>
                <div style={{ fontSize: 'var(--font-xxs)', color: 'var(--text-tertiary)' }}>{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Plans */}
      <section className="responsive-container" style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)'
      }}>
        <h2 className="responsive-heading" style={{
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: 'clamp(0.5rem, 2vw, 1rem)'
        }}>
          價格方案
        </h2>
        <p className="responsive-text" style={{
          textAlign: 'center',
          color: 'var(--text-secondary)',
          marginBottom: 'clamp(2rem, 5vw, 3rem)'
        }}>
          AI 驅動的社群經營服務
        </p>

        <div className="responsive-grid" style={{
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 'clamp(1rem, 3vw, 2rem)',
          marginBottom: 'clamp(2rem, 5vw, 3rem)'
        }}>
          {[
            {
              name: 'AI 基礎版',
              price: '490',
              unit: '/ 帳號 / 月',
              subtitle: '個人或小品牌',
              features: [
                '每日 2 篇自動發文',
                '固定模板 + 固定語氣',
                '基礎圖卡生成',
                '排程發佈功能',
                '基礎數據分析'
              ],
              color: '#667eea'
            },
            {
              name: 'AI 專業版',
              price: '790',
              unit: '/ 帳號 / 月',
              subtitle: '中小企業、專業創作者',
              features: [
                '每日 3 篇自動發文',
                '多模板自由切換',
                '自動生成含 CTA 文案',
                '日常經營 + 特殊目的貼文',
                '進階數據分析',
                '多平台同步'
              ],
              popular: true,
              color: '#2563eb'
            },
            {
              name: 'AI 品牌版',
              price: '3990',
              unit: '/ 帳號 / 月',
              subtitle: '需要高度一致性的企業品牌',
              features: [
                '每日 5 篇自動發文',
                '可上傳專屬模板與品牌語氣',
                '自動套用企業 Logo、水印',
                '可設定輸出風格',
                '整合品牌資料庫',
                '專屬推廣內容生成'
              ],
              color: '#1d4ed8'
            }
          ].map((plan, index) => {
            const planType = index === 0 ? 'basic' : index === 1 ? 'professional' : 'brand';
            const accounts = selectedPlans[planType].accounts;
            const totalPrice = parseInt(plan.price) * accounts;
            
            return (
              <div
                key={index}
                style={{
                  background: plan.popular 
                    ? '#dbeafe' 
                    : '#f3f4f6',
                  border: 'none',
                  borderRadius: 'clamp(16px, 3vw, 20px)',
                  padding: 'clamp(1.5rem, 4vw, 2rem)',
                  position: 'relative',
                  transform: plan.popular ? 'scale(1.05)' : 'scale(1)',
                  boxShadow: plan.popular 
                    ? '0 20px 40px rgba(118, 75, 162, 0.2)' 
                    : '0 8px 24px rgba(0, 0, 0, 0.1)'
                }}
              >
                {plan.popular && (
                  <div style={{
                    position: 'absolute',
                    top: '-12px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                    color: 'white',
                    padding: '0.4rem 1.2rem',
                    borderRadius: '20px',
                    fontSize: 'var(--font-xxxs)',
                    fontWeight: '700',
                    boxShadow: '0 4px 12px rgba(118, 75, 162, 0.4)'
                  }}>
                    最受歡迎
                  </div>
                )}
                
                <h3 style={{ 
                  fontSize: 'var(--font-base)', 
                  marginBottom: '0.5rem', 
                  fontWeight: '700',
                  color: '#1f2937'
                }}>
                  {plan.name}
                </h3>
                
                <div className="responsive-text" style={{ 
                  color: '#6b7280', 
                  marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                  fontWeight: '500'
                }}>
                  適合：{plan.subtitle}
                </div>
                
                <div style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
                  <div style={{ marginBottom: '0.5rem' }}>
                    <span style={{
                      fontSize: 'var(--font-4xl)',
                      fontWeight: '800',
                      color: '#1f2937',
                      lineHeight: '1'
                    }}>
                      NT${plan.price}
                    </span>
                  </div>
                  <span style={{ color: '#6b7280', fontSize: 'var(--font-xs)', fontWeight: '500' }}>{plan.unit}</span>
                </div>

                {/* 帳號數量選擇器 */}
                <div style={{ marginBottom: '1.5rem' }}>
                  <div style={{ 
                    fontSize: 'var(--font-xxs)', 
                    color: '#374151', 
                    marginBottom: '0.5rem',
                    fontWeight: '600'
                  }}>
                    選擇帳號數量：
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '0.5rem',
                    marginBottom: '1rem'
                  }}>
                    <button
                      onClick={() => handleAccountChange(planType, Math.max(1, accounts - 1))}
                      style={{
                        background: 'white',
                        border: '1px solid #d1d5db',
                        color: '#374151',
                        width: '32px',
                        height: '32px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: '600',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                      }}
                    >
                      −
                    </button>
                    <span style={{ 
                      color: '#1f2937', 
                      fontSize: 'var(--font-sm)', 
                      fontWeight: '700',
                      minWidth: '40px',
                      textAlign: 'center'
                    }}>
                      {accounts}
                    </span>
                    <button
                      onClick={() => handleAccountChange(planType, accounts + 1)}
                      disabled={planType === 'basic' && accounts >= 3}
                      style={{
                        background: (planType === 'basic' && accounts >= 3) ? '#f3f4f6' : 'white',
                        border: '1px solid #d1d5db',
                        color: (planType === 'basic' && accounts >= 3) ? '#9ca3af' : '#374151',
                        width: '32px',
                        height: '32px',
                        borderRadius: '8px',
                        cursor: (planType === 'basic' && accounts >= 3) ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: '600',
                        boxShadow: (planType === 'basic' && accounts >= 3) ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)'
                      }}
                    >
                      +
                    </button>
                    <span style={{ 
                      color: '#6b7280', 
                      fontSize: 'var(--font-xxs)',
                      marginLeft: '0.5rem',
                      fontWeight: '500'
                    }}>
                      個帳號
                    </span>
                  </div>
                  
                  {/* 平台限制說明 */}
                  {planType === 'basic' && (
                    <div style={{
                      fontSize: 'var(--font-xxxs)',
                      color: '#9ca3af',
                      marginBottom: '0.5rem',
                      fontWeight: '500'
                    }}>
                      ✨ 支援平台：Instagram、Facebook、Threads（最多3個帳號）
                    </div>
                  )}
                  
                  {/* 總價顯示 */}
                  <div style={{
                    background: 'white',
                    padding: '0.75rem',
                    borderRadius: '12px',
                    textAlign: 'center',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                  }}>
                    <div style={{ 
                      fontSize: 'var(--font-xxxs)', 
                      color: '#9ca3af',
                      marginBottom: '0.25rem',
                      fontWeight: '600'
                    }}>
                      月費總計
                    </div>
                    <div style={{
                      fontSize: 'var(--font-xl)',
                      fontWeight: '800',
                      color: '#1f2937'
                    }}>
                      NT${totalPrice.toLocaleString()}
                    </div>
                  </div>
                </div>

                <ul style={{ listStyle: 'none', padding: 0, marginBottom: '2rem' }}>
                  {plan.features.map((feature, fi) => (
                    <li key={fi} style={{
                      padding: '0.5rem 0',
                      borderBottom: fi === plan.features.length - 1 ? 'none' : '1px solid rgba(255,255,255,0.05)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <span style={{ color: plan.color, fontSize: 'var(--font-xs)', fontWeight: '600' }}>✓</span>
                      <span style={{ color: '#374151', fontSize: 'var(--font-xxs)', fontWeight: '500' }}>{feature}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => handlePurchase(planType, plan.name, parseInt(plan.price))}
                  style={{
                    width: '100%',
                    background: plan.popular ? 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)' : '#374151',
                    border: 'none',
                    color: 'white',
                    padding: '1rem',
                    borderRadius: '12px',
                    fontSize: 'var(--font-xs)',
                    fontWeight: '700',
                    cursor: 'pointer',
                    boxShadow: plan.popular ? '0 8px 20px rgba(59, 130, 246, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.15)',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = plan.popular ? '0 12px 24px rgba(59, 130, 246, 0.4)' : '0 8px 16px rgba(0, 0, 0, 0.2)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = plan.popular ? '0 8px 20px rgba(59, 130, 246, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.15)';
                  }}
                >
                  立即購買 ({accounts} 個帳號)
                </button>
              </div>
            );
          })}
        </div>

        {/* 矩陣方案 - 特別設計 */}
        <div 
          style={{
            background: "#dbeafe",
            border: 'none',
            borderRadius: '24px',
            padding: '2.5rem',
            position: 'relative',
            overflow: 'hidden',
            marginTop: 'calc(2rem + 200px)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 0 20px rgba(59, 130, 246, 0.3), 0 8px 24px rgba(59, 130, 246, 0.2)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
            e.currentTarget.style.boxShadow = '0 0 30px rgba(59, 130, 246, 0.5), 0 20px 40px rgba(59, 130, 246, 0.3)';
            // 移除邊框變化
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 0 20px rgba(59, 130, 246, 0.3), 0 8px 24px rgba(59, 130, 246, 0.2)';
            // 移除邊框變化
          }}
        >
          {/* 特殊標籤 */}
          <div style={{
            position: 'absolute',
            top: '-1px',
            right: '2rem',
            background: "var(--bg-primary)",
            color: 'var(--text-primary)',
            padding: '0.5rem 1.5rem',
            borderRadius: '0 0 12px 12px',
            fontSize: 'var(--font-xxxs)',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <Icon icon="mdi:rocket-launch" style={{ fontSize: 'var(--font-xs)' }} />
            矩阵行销
          </div>

          {/* 頭部區域 - 標題和價格 */}
          <div style={{ textAlign: 'center', marginBottom: 'clamp(2rem, 5vw, 3rem)', marginTop: 'clamp(1.5rem, 4vw, 2rem)' }}>
            <h3 style={{ 
              fontSize: 'var(--font-xl)', 
              fontWeight: '700', 
              color: '#1f2937', 
              margin: 0, 
              marginBottom: 'clamp(1rem, 3vw, 1.5rem)' 
            }}>
              AI 矩陣方案・小型版
            </h3>
            
            <div style={{ 
              fontSize: 'var(--font-xs)', 
              color: '#374151', 
              marginBottom: 'clamp(1.5rem, 4vw, 2rem)',
              fontWeight: '500',
              maxWidth: '600px',
              margin: '0 auto clamp(1.5rem, 4vw, 2rem)'
            }}>
              適合：需要快速建立「多帳號行銷矩陣」的企業
            </div>

            <div style={{ marginBottom: 'clamp(1rem, 3vw, 1.5rem)' }}>
              <div style={{
                fontSize: 'var(--font-4xl)',
                fontWeight: '800',
                color: '#3b82f6',
                lineHeight: '1.1'
              }}>
                NT$75,000
              </div>
              <div style={{ color: '#6b7280', fontSize: 'var(--font-xs)', marginTop: '0.5rem' }}>
                / 套（5 隻帳號，綁定三個月）
              </div>
            </div>
          </div>

          {/* 功能特色區域 */}
          <div style={{ marginBottom: 'clamp(2rem, 5vw, 3rem)' }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: 'clamp(1rem, 3vw, 1.5rem)',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              {[
                '每日 5 篇專業發文（每帳號）',
                '專業行銷人員 15 分鐘需求訪談',
                '量身規劃完整矩陣貼文策略',
                '每個帳號具有人物設定（persona）',
                '多角度觸及市場',
                '形成小型內容矩陣，強化演算法效應'
              ].map((feature, fi) => (
                <div key={fi} style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  padding: 'clamp(0.75rem, 2vw, 1rem)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  backdropFilter: 'blur(5px)'
                }}>
                  <span style={{ 
                    color: '#374151', 
                    fontSize: 'var(--font-base)',
                    background: 'white',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>✓</span>
                  <span style={{ 
                    color: '#374151', 
                    fontWeight: '500', 
                    fontSize: 'var(--font-xs)',
                    lineHeight: '1.4'
                  }}>
                    {feature}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* 按鈕區域 */}
          <div style={{ textAlign: 'center' }}>
            <button
              onClick={() => window.location.href = 'mailto:official@viralarc-ai.com?subject=矩陣方案諮詢'}
              style={{
                background: '#3b82f6',
                border: 'none',
                color: 'white',
                padding: 'clamp(1.2rem, 3.5vw, 1.5rem) clamp(2.5rem, 6vw, 3.5rem)',
                borderRadius: '16px',
                fontSize: 'var(--font-base)',
                fontWeight: '700',
                cursor: 'pointer',
                boxShadow: '0 8px 24px rgba(59, 130, 246, 0.3)',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 12px 32px rgba(59, 130, 246, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 24px rgba(59, 130, 246, 0.3)';
              }}
            >
              立即諮詢
            </button>
            <div style={{ 
              fontSize: 'var(--font-xxs)', 
              color: 'white', 
              marginTop: '0.75rem',
              fontWeight: '500'
            }}>
              需求評估 + 策略規劃
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: "var(--bg-primary)",
        borderTop: '1px solid rgba(255,255,255,0.1)',
        textAlign: 'center'
      }}>
        <h2 className="responsive-heading" style={{
          fontWeight: '700',
          marginBottom: 'clamp(0.5rem, 2vw, 1rem)'
        }}>
          準備好用 AI 改變你的社群經營了嗎？
        </h2>
        <p className="responsive-text" style={{
          color: 'var(--text-secondary)',
          marginBottom: 'clamp(1.5rem, 4vw, 2rem)'
        }}>
          加入超過 100+ 品牌，開始自動化社群經營
        </p>
        <button
          onClick={() => navigate('/register')}
          style={{
            background: '#3b82f6',
            border: 'none',
            color: 'white',
            padding: 'clamp(0.75rem, 2vw, 1rem) clamp(2rem, 5vw, 3rem)',
            borderRadius: '12px',
            fontSize: 'var(--font-xs)',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 0 20px rgba(59, 130, 246, 0.4), 0 10px 30px rgba(59, 130, 246, 0.3)',
            animation: 'glow 2s ease-in-out infinite alternate'
          }}
        >
          免費試用 7 天
        </button>
      </section>

      {/* Footer */}
      <footer className="responsive-container" style={{
        padding: 'clamp(2rem, 5vw, 3rem) clamp(1rem, 5vw, 5%)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 'clamp(1rem, 3vw, 2rem)'
      }}>
        <div>
          <div className="responsive-subheading" style={{
            fontWeight: '700',
            marginBottom: '0.5rem'
          }}>
            ViralArc AI
          </div>
          <div className="responsive-text" style={{ color: 'var(--text-tertiary)' }}>
            © 2024 ViralArc. All rights reserved.
          </div>
        </div>
        <div className="flex-container" style={{ gap: 'clamp(1rem, 3vw, 2rem)', justifyContent: 'flex-end' }}>
          <a href="#" className="responsive-text" style={{ color: 'var(--text-secondary)', textDecoration: 'none', whiteSpace: 'nowrap' }}>隱私政策</a>
          <a href="#" className="responsive-text" style={{ color: 'var(--text-secondary)', textDecoration: 'none', whiteSpace: 'nowrap' }}>服務條款</a>
          <a href="mailto:official@viralarc-ai.com" className="responsive-text" style={{ color: 'var(--text-secondary)', textDecoration: 'none', whiteSpace: 'nowrap' }}>聯絡我們</a>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;